export const EMAIL_SKINS = [
    {
        id: "brand",
        title: "Brand",
        description: "Primary accents from your store theme.",
    },
    {
        id: "gray",
        title: "Gray",
        description: "Neutral surfaces with brand CTAs.",
    },
    {
        id: "dark",
        title: "Dark",
        description: "Dark background; brand buttons stay on-theme.",
    },
];

export const HANDLER_ORDER_CONFIRM = "order/confirm_notify";
export const HANDLER_ORDER_READY = "order/ready_notify";
export const HANDLER_ORDER_ON_ROUTE = "order/on_route_notify";
export const HANDLER_ORDER_COMPLETED = "order/completed_notify";
export const HANDLER_ORDER_DECLINED = "order/declined_notify";
export const HANDLER_CONTACT_BUSINESS = "contact/business_owner";
